export const menuItems = [
  // {
  //     icon: 'fas fa-home',
  //     router: '/app/home'
  // },

  {
    icon: "fal fa-chart-line-up",
    label: "menu.incomes",
    router: "/app/incomes",
  },
  {
    icon: "fal fa-chart-line-down",
    label: "menu.costs",
    router: "/app/costs",
  },
  {
    icon: "fal fa-chart-column",
    label: "menu.cashFlow",
    router: "/app/cashflow",
  },
  {
    icon: "fal fa-users",
    label: "menu.wage",
    router: "/app/employee/list",
  },

  // {
  //     icon: 'fas fa-user-alt',
  //     router: '/app/profile'
  // },
];
